import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=1e4f76dd&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=1e4f76dd&prod&lang=scss&scoped=true&"
import style1 from "./Question.vue?vue&type=style&index=1&id=1e4f76dd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4f76dd",
  null
  
)

export default component.exports